import React from 'react';

// Fußzeile unter der Login-Karte (design_handoff_login §3): Tokens statt fester Grautöne, keine Versalien mehr.
const Footer: React.FC = () => {
  return (
    <div className="flex flex-col items-center text-center" style={{ gap: 2, fontSize: 12.5, color: 'var(--ink3)' }}>
      <span>© 2026 Schwede</span>
      <span>Immobilienmanagement</span>
    </div>
  );
};

export default Footer;
